// ==============================|| OVERRIDES - MENU ||============================== //

export default function Menu() {
  return {
    MuiMenu: {
      styleOverrides: {
        paper: {
          backgroundColor: 'rgb(44, 62, 74)',
          border: '1px solid rgb(48, 67, 87)'
        }
      }
    }
  };
}
